import { FC, useContext, useRef } from 'react'
import { useRouter } from 'next/router'

import Auth from 'store/auth'
import Banner from 'components/course/course-common/banner/banner'
import CourseBtnBack from 'components/course/course-common/course-btn-back/course-btn-back'
import MainBlock from 'components/course/course-osteoporosis/main-block/main-block'
import PopupBuyCourse from 'components/popups/popup-buy-course/popup-buy-course'
import Purchase from 'components/course/unpaid-course/purchase/purchase'
import Button from 'components/parts/button/button'
import SEOMetatags from 'components/parts/seo-metatags/seo-metatags'
import MainLayout from 'containers/main-layout/main-layout'
import PopupWrapperNew from 'containers/popup-wrapper-new/popup-wrapper-new'
import WidthLimiter from 'containers/width-limiter/width-limiter'
import screenSizeContext from 'context/screenSizeContext'
import SEOContext from 'context/SEOContext'
import useSetView from 'hooks/useSetView'
import useToggle from 'hooks/useToggle'
import useToggleAfterScrollBlock from 'hooks/useToggleAfterScrollBlock'

import { osteoBannerData } from 'components/course/course-common/banner/banner-content/data'
import { osteoBannerImgData } from 'components/course/course-common/banner/banner-image/data'
import { MediaNames } from 'constants/media-constanst'
import { CourseOsteporosisSEO } from 'constants/SEO'
import { ICourseType } from 'constants/types/course.types'
import { cutHashFromURL } from 'utils/getURLData'
import { popupName } from 'constants/auth/auth-data'

import styles from 'styles/course/course.module.scss'

const COURSE_ID = 2
interface ICoursePage {
  course: ICourseType
}

const OsteoporosisPage: FC<ICoursePage> = ({ course }) => {
  const [mobilePopupOpened, toggleMobilePopup] = useToggle()
  const [outerPurchasePop, toggleOuterPurchasePop] = useToggle()

  const { windowSize } = useContext(screenSizeContext)
  const { isNotAuthorized } = Auth.useAuth()
  const router = useRouter()
  const path = cutHashFromURL(router.asPath)

  useSetView({ materialId: COURSE_ID, materialType: 'course', isForceCancel: course.available })

  const isMobile = windowSize === MediaNames.MOBILE_SMALL
  const firstTxtBlockRef = useRef<HTMLDivElement>(null)
  const isShownButton = useToggleAfterScrollBlock(firstTxtBlockRef)
  const paymentValue = router.query.paymentPopup ? String(router.query.paymentPopup) : ''

  const purchaseHandler = () => {
    if (isNotAuthorized) {
      router.push(`${path}#${popupName.registration}`)
    } else {
      toggleOuterPurchasePop()
    }
  }

  return (
    <>
      <SEOMetatags data={CourseOsteporosisSEO} />
      <SEOContext.Provider value={CourseOsteporosisSEO}>
        <MainLayout noLines noBtnUp noInformLine noNavbarItems>
          <WidthLimiter modificator={styles.wrapper}>
            <CourseBtnBack link="/program" />
            <Banner
              clickHandler={purchaseHandler}
              imgData={osteoBannerImgData}
              contentData={osteoBannerData}
              isNotAuthorized={isNotAuthorized}
            />
            <div className={styles.layoutWrapper}>
              <MainBlock
                isNotAuthorized={isNotAuthorized}
                purchaseHandler={purchaseHandler}
                price={Number(course.price)}
                courseId={COURSE_ID}
                refBlock={firstTxtBlockRef}
              />
              <div className={styles.consultationForm}>
                <Purchase courseInfo={course} />
              </div>
            </div>
          </WidthLimiter>

          {isShownButton && (
            <div className={styles.fixedButton}>
              <Button onClick={purchaseHandler}>
                {isNotAuthorized ? 'Записаться на курc' : 'Оплатить курс'}
              </Button>
            </div>
          )}
          {mobilePopupOpened && isNotAuthorized && (
            <PopupWrapperNew
              isBottom
              closePopup={toggleMobilePopup}
              popupBlockMod={styles.popup}
              isFullScreen={isMobile}
            >
              <Purchase courseInfo={course} outerMainPopHandler={toggleOuterPurchasePop} />
            </PopupWrapperNew>
          )}
          {outerPurchasePop && (
            <PopupBuyCourse
              courseInfo={course}
              handleShowPopup={toggleOuterPurchasePop}
              paymentPopup={paymentValue}
            />
          )}
        </MainLayout>
      </SEOContext.Provider>
    </>
  )
}

export default OsteoporosisPage
